import { Actions, Context } from 'vuex-smart-module';
import CartStore from '@/modules/cart/store';
import CartState from '@/modules/cart/store/state';
import { Store } from 'vuex';
import { Auth } from '../types';
import AuthGetters from './getters';
import AuthMutations from './mutations';
import AuthState from './state';

export default class AuthActions extends Actions<
  AuthState,
  AuthGetters,
  AuthMutations,
  // eslint-disable-next-line no-use-before-define
  AuthActions
> {
  cart_store!: Context<typeof CartStore>;

  $init(store: Store<CartState>): void {
    this.cart_store = CartStore.context(store);
  }

  set_token(token: string) {
    this.mutations.SET_TOKEN(token);
    localStorage.setItem(Auth.TokenPrefix.JWT, token);
  }

  del_token() {
    this.mutations.DEL_TOKEN();
  }
}
